export default "__VITE_ASSET__CYwXuvOL__"